import useMutation from '../../../../ReactQuery/useMutation';
import { post } from '../../../../redux/api';
import type {
  SocialLoginSelectOrgRequest,
  SocialLoginSelectOrgResponse,
} from '../../../../../shared/types/routes/auth/socialLogin';

function selectSocialOrg(request: SocialLoginSelectOrgRequest) {
  return post<SocialLoginSelectOrgRequest, SocialLoginSelectOrgResponse>(
    '/account/social/select-org',
    request,
  );
}

/**
 * Multi-org social login: finalize the deferred login by telling the backend which org to sign into.
 */
export function useSelectSocialOrg() {
  return useMutation({
    mutationFn: selectSocialOrg,
  });
}
